import { useState } from 'react'
import { useToggleEnvironment } from './use-toggle-environment'
import { useVerifyPathPermission } from './use-verify-path-permission'
import { useMediaQuery } from '@mui/material'
import { queryClient } from '@yuno/dashboard-api-mfe'

export const useModeState = ({ organization }) => {
  const { fetchRoles } = useVerifyPathPermission()
  const { toggleModeStatus } = useToggleEnvironment()
  const matches = useMediaQuery('(max-width: 1023px)')
  const [openDrawer, setOpenDrawer] = useState(!matches)
  const [testingEnvironment, setTestingEnvironment] = useState(false)

  const handleTestingState = (isTesting) => {
    if (
      (isTesting === null || isTesting === undefined) &&
      organization?.status === 'ACTIVE'
    ) {
      setTestingEnvironment(false)
      localStorage.setItem('isTesting', 'OFF')
      window.dispatchEvent(
        new StorageEvent('storage', { key: 'isTesting', newValue: 'OFF' }),
      )
    } else if (isTesting !== null && isTesting !== undefined) {
      setTestingEnvironment(isTesting === 'ON')
      localStorage.setItem('isTesting', isTesting)
      window.dispatchEvent(
        new StorageEvent('storage', {
          key: 'isTesting',
          newValue: isTesting,
        }),
      )
    } else {
      setTestingEnvironment(true)
      localStorage.setItem('isTesting', 'ON')
      window.dispatchEvent(
        new StorageEvent('storage', {
          key: 'isTesting',
          newValue: 'ON',
        }),
      )
    }
  }

  const handleTestingStateStaff = (organizationSelected) => {
    const isTesting = localStorage.getItem('isTesting')

    if (!isTesting && organizationSelected?.status !== 'ACTIVE') {
      setTestingEnvironment(true)
      localStorage.setItem('isTesting', 'ON')
      window.dispatchEvent(
        new StorageEvent('storage', { key: 'isTesting', newValue: 'ON' }),
      )
      return
    }
    if (isTesting) {
      setTestingEnvironment(isTesting === 'ON')
      localStorage.setItem('isTesting', isTesting)
      window.dispatchEvent(
        new StorageEvent('storage', { key: 'isTesting', newValue: isTesting }),
      )
      return
    }
    if (
      organizationSelected &&
      organizationSelected?.code !== organization?.code
    ) {
      if (organizationSelected?.status === 'ACTIVE') {
        setTestingEnvironment(false)
        localStorage.setItem('isTesting', 'OFF')
        window.dispatchEvent(
          new StorageEvent('storage', { key: 'isTesting', newValue: 'OFF' }),
        )
      } else {
        setTestingEnvironment(true)
        localStorage.setItem('isTesting', 'ON')
        window.dispatchEvent(
          new StorageEvent('storage', {
            key: 'isTesting',
            newValue: 'ON',
          }),
        )
      }
    }
  }

  const handleToggleDrawer = () => {
    setOpenDrawer((prev) => {
      localStorage.setItem('DRAWER', prev ? 'closed' : 'opened')

      window.dispatchEvent(
        new StorageEvent('storage', {
          key: 'DRAWER',
          newValue: prev ? 'closed' : 'opened',
        }),
      )

      return !prev
    })

    window.dispatchEvent(new Event('openDrawer'))
  }

  const toggleEnvironment = async () => {
    const current = toggleModeStatus()

    queryClient.removeQueries({})
    queryClient.resetQueries({})

    window.dispatchEvent(
      new StorageEvent('storage', { key: 'isTesting', newValue: current }),
    )

    setTestingEnvironment(current === 'ON')

    const clearFiltersEvent = new Event('CLEAR_FILTER')
    window.dispatchEvent(clearFiltersEvent)

    //Se comenta para mejorar performance al cambiar de ambiente

    fetchRoles()

    //;(window as any).singleSpaNavigate('/')
  }

  return {
    openDrawer,
    handleToggleDrawer,
    handleTestingState,
    handleTestingStateStaff,
    toggleEnvironment,
    setTestingEnvironment,
    testingEnvironment,
  }
}
